import React from 'react';
import PropTypes from 'prop-types';
import InputCont from '../../../Shared/Form/InputCont';
import { Defines } from '../../../project/Defines';

export default function Installer(props) {
    const { dataItem, onChangeData, disabled, validation, setDataItem } = props;

    return (
        <view light="" scroll_wrapper="">
            <div className='section_group'>
                <div className='sections '>
                    <form>
                        <InputCont
                            label='text.installer_name_required'
                            inputProps={{ disabled, name: 'installer_name', validation, value: dataItem.installer_name, placeholder: "", onChange: onChangeData }}
                        />
                        <InputCont
                            label='text.installer_company_required'
                            inputProps={{ disabled, name: 'installer_company', validation, value: dataItem.installer_company, placeholder: "", onChange: onChangeData }}
                        />
                        <InputCont
                            label='text.installer_zip_code_required'
                            inputProps={{ disabled, name: 'installer_zip_code', validation, value: dataItem.installer_zip_code, placeholder: "", onChange: onChangeData }}
                        />
                        <InputCont
                            label='text.installer_city_required'
                            inputProps={{ disabled, name: 'installer_city', validation, value: dataItem.installer_city, placeholder: "", onChange: onChangeData }}
                        />
                    </form>
                </div>
                <div className='sections '>
                    <form>
                    <InputCont
                        label='text.installer_street_required'
                        inputProps={{ disabled, name: 'installer_street', validation, value: dataItem.installer_street, placeholder: "", onChange: onChangeData }}
                    />
                    <InputCont
                        label='text.installer_phone_required'
                        inputProps={{ disabled, name: 'installer_phone', validation, value: dataItem.installer_phone, placeholder: "", onChange: onChangeData }}
                    />
                    <InputCont
                            label='text.installer_email_required'
                            inputProps={{
                                validation,
                                disabled,
                                name: 'installer_email',
                                value: dataItem.installer_email,
                                placeholder: "",
                                onChange: onChangeData
                            }}
                        />
                    <InputCont
                        label='text.installation_date_required'
                        inputProps={{
                            // disabled: true,
                            validation,
                            name: 'installation_date',
                            type: 'date',
                            dataItem,
                            dataField: 'installation_date',
                            format: Defines.Format.MomentDate,
                            placeholder: "",
                            setDataItem
                        }}
                    />
                    </form>
                </div>
            </div>
        </view>
    );
}

Installer.propTypes = {
    dataItem: PropTypes.object.isRequired,
    onChangeData: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    validation: PropTypes.object,
    setDataItem: PropTypes.func.isRequired
};